import { generateUniqueId, INIT_ENCOUNTER_NAME, COLOR_GREEN, COLOR_RED} from '../../constants'
import { useImportedPlayers } from '../../../../../providers/ImportedPlayersProvider';
import { useHomebrewProvider } from '../../../../../providers/HomebrewProvider';
import 'react-tabs/style/react-tabs.css';
import { useEffect, useState } from 'react';
import SpellBlock from '../Statblock/PopupBlocks/SpellBlock';
import ConditionBlock from "../Statblock/PopupBlocks/ConditionBlock";
import ImportList from "./ImportList"
import Book from '../Statblock/PopupBlocks/Book';

const alignmentOptions = [
    'good', 'evil', 'neutral',
    'true', 'unaligned', 'lawful',
    'chaotic', 'lawful good', 'neutral good',
    'chaotic good', 'lawful neutral', 
    'true neutral', 'chaotic neutral',
    'lawful evil','nuetral evil',
    'chaotic evil','unaligned' 
]

function getKey(c) {
    let keyExtra = ""
    if(c?.from === 'dnd_b')
        keyExtra = c.dnd_b_player_id
    else if(c?.dmb_homebrew_guid)
        keyExtra = c?.dmb_homebrew_guid
    else 
        keyExtra = c.sourceShort

    return c.name + keyExtra;
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
}

function highlightSubstring(substring, fullString) {
    if (!substring) return fullString;
    const parts = fullString.split(new RegExp(`(${escapeRegExp(substring)})`, 'gi')); // Split on the substring, keeping it in the result

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === substring.toLowerCase() ? (
                    <b key={index} style={{
                        textShadow: '1px 1px 2px gray',
                    }}>{part}</b> 
                ) : (
                    part 
                )
            )}
        </span>
    );
}

const SearchTab = ({tabSelectedIndex, displayedItems, setCurrentEncounter, encounterGuid, searchTerm, setSearchSelectedCreature, socket}) => {    
    
    const {removeFromImportList} = useImportedPlayers();
    const {removeFromHomebrewList} = useHomebrewProvider();
    const [xClicked, setXClicked] = useState({click: false, index: undefined});
    const [shake, setShake] = useState(undefined);

    useEffect(() => {
        if(shake) {
            setTimeout(() => {
                setShake(undefined)
            }, 2000)
        }
    }, [shake])

    useEffect(() => {
        if(xClicked.click) {
            setTimeout(() => {
                setXClicked({click: false, index: undefined})
            }, 2000)
        }

    }, [xClicked])

    const handleSearchSelectCreature = async (creature, action, event=undefined, index=undefined) => {
        event?.stopPropagation();
       
        if(creature?.creatureGuid !== undefined) {
            if(action === "add") {
                handleSelectCreature(creature, action)                
            } else if(action === "select" ) {
                if(!creature?.dnd_b_player_id) {
                    handleSelectCreature(creature, action)            
                } else {
                    setShake(creature.creatureGuid)
                }
            }
        }
    };

    const handleSelectCreature = (creature, action) => {
        if(action === "add") {
            setCurrentEncounter(prev => {
                // set to prev.encounterGuid, passed in encounterGuid could be stale
                let eGuid = prev.encounterGuid;
                let newCreature = {...creature, creatureGuid: generateUniqueId(), encounterGuid: eGuid}
                if(prev.creatures.length === 0 && prev.encounterName === INIT_ENCOUNTER_NAME) {
                    socket.emit("newEncounter", eGuid, '', prev.folder_dir)
                }

                // If there are no creatures in this list, then create the encounter in the database and add to it
                socket.emit("addCreatureToEncounter", newCreature)
              
                // Return the updated state with the new creature added
                return {
                  ...prev,
                  creatures: [...prev.creatures, newCreature]
                };
            });           
        } else if(action === "select") {
            if(creature.dmb_homebrew_guid) {
                setSearchSelectedCreature({...creature});
            } else {
                let newGuid = generateUniqueId();
                setSearchSelectedCreature({...creature, creatureGuid: newGuid});
            }
        }

    };

    const handleXClick = async (c, index) => {
        let handled = c?.dnd_b_player_id 
                        ? await removeFromImportList(c, index)
                        : await removeFromHomebrewList(c, index)

        if(handled) { 
            setXClicked({click: true, index})
        }
    }

    const colors = {
        "enemy": COLOR_RED,
        "neutral": '#999999',
        "ally": COLOR_GREEN,
        "pet": COLOR_GREEN
    }

    if (tabSelectedIndex === 2) {
        return <ImportList displayedItems={displayedItems} encounterGuid={encounterGuid} searchTerm={searchTerm} handleSearchSelectCreature={handleSearchSelectCreature} xClicked={xClicked} handleXClick={handleXClick} colors={colors} shake={shake}/>
    }

    if (tabSelectedIndex === 3) {
        return (
            <>
                {displayedItems.length > 0 ? ( displayedItems?.map((spell) => (
                    <li className={`spellListItem`} key={spell.name + spell.source}>
                        <SpellBlock spell={spell} enableCollapse={true}/>
                    </li>
                ))) : (
                    <div className='searchListCreatureContainer noCreaturesFound'>No Spells found...</div>
                )}
            </>
        );
    }

    if (tabSelectedIndex === 4) {
        return (
            <>
                {displayedItems.length > 0 ? ( displayedItems?.map((condition) => (
                    <li className={`spellListItem`} key={condition.name + condition.source}>
                        <ConditionBlock condition={condition} enableCollapse={true}/>
                    </li>
                ))) : (
                    <div className='searchListCreatureContainer noCreaturesFound'>No Conditions found...</div>
                )}
            </>
        );
    }


    // Books
    if (tabSelectedIndex === 5) {
        // let bookArray = displayedItems;
        let adventureNames = displayedItems;
        return (
            <>
                {adventureNames.map(bookInfo => ( 
                    <li className='bookListItem' key={bookInfo.id + "outer"}>
                        <Book bookinfo={bookInfo} handleSelectCreature={handleSelectCreature}/>
                    </li>
                ))}
            
            </>
        );
    }

    return (
        <>
            {displayedItems.length > 0 ? ( displayedItems?.map((creature, index) => (
                <li
                    className="listItem"
                    key={getKey(creature)}
                    onClick={(e) => handleSearchSelectCreature(creature, "select", e, index)}
                >
                    <div className={`searchListCreatureContainer ${(xClicked.click && index > xClicked.index) ? "animated-box" : ""}`}
                        style={creature?.alignment ? {borderLeft: `6px solid ${colors[creature?.alignment]}`} : {}}>
                        <div className="monsterEncounterIconContainer">
                            <img className="monsterSearchIcon" src={creature.avatarUrl} alt={"list Icon"} />
                        </div>
                        <div className='searchListCreatureDetails'>
                            <span>
                                <strong>{highlightSubstring(searchTerm, creature.name)}</strong>  
                            </span>
                            <div className='searchCreatureSmallDetails'>
                                {creature?.dmb_homebrew_guid ? (
                                    <>
                                        <span className='monsterSearchDetailText'> CR: {creature.challenge_rating}</span>
                                        {creature?.creature_type !== "--" && <span className='monsterSearchDetailText'> - {highlightSubstring(searchTerm, creature.creature_type)}</span>}
                                        <span className='monsterSearchDetailText'> - {creature?.dmb_homebrew_guid}</span>
                                        <span className='monsterSearchDetailText'> - {creature?.alignment}</span>
                                    </>
                                ) : (
                                    <>
                                        <span className='monsterSearchDetailText'> CR: {creature.cr}</span>
                                        <span className='monsterSearchDetailText'> - {highlightSubstring(searchTerm, creature.creature_type)}</span>
                                        <span className='monsterSearchDetailText'> - {creature.sourceShort}</span>
                                        {(searchTerm.length >= 4 && alignmentOptions.includes(searchTerm.toLowerCase())) && 
                                            <span className='monsterSearchDetailText' style={{textShadow: '1px 1px 2px gray',}}> 
                                                - <b>{searchTerm.toLowerCase()}</b>
                                            </span>
                                        }
                                    </>
                                )}
                            </div>
                        </div>
                        <div className='searchListButtonContainer'>
                            {creature?.dmb_homebrew_guid &&
                                <button className='searchCreatureX' onClick={(event) => {
                                    event.stopPropagation();
                                    handleXClick(creature, index) ;
                                }}>
                                    ❌
                                </button>
                            }
                            <button className='monsterSearchAdd' onClick={(e) => handleSearchSelectCreature(creature, "add", e, index)}>
                                ➕
                            </button>
                        </div>

                    </div>
                </li>
            ))) : (
                <div className='searchListCreatureContainer noCreaturesFound'>No creatures found...</div>
            )}
        </>
    );
}

export default SearchTab;